import { PieChart, Pie, Cell } from "recharts";

const data = [
  { name: "Sales", value: 30 },
  { name: "Marketing", value: 20 },
  { name: "Development", value: 40 },
  { name: "Support", value: 10 },
];
const colors = ["#FF6384", "#36A2EB", "#FFCE56", "#4CAF50"];

const Dashboard = () => (
  <div className="flex flex-col min-h-screen bg-gray-900 text-white">
    <div className="flex flex-col justify-center items-center px-4 py-8">
      <h2 className="text-2xl font-bold text-white mb-4">
        Management loves charts
      </h2>
      <PieChart width={320} height={320}>
        <Pie data={data} dataKey="value" outerRadius={100}>
          {data.map((entry, index) => (
            <Cell key={`cell-${index}`} fill={colors[index]} />
          ))}
        </Pie>
      </PieChart>
      <p className="text-gray-400 mt-4">
        Actual dashboard still in development. Coming soon!
      </p>
    </div>
  </div>
);

export default Dashboard;
